{
  "header": {
    "title": "Fragezeitplan",
    "description": "Überprüfen und analysieren Sie frühere Feedback-Antworten"
  },
  "categorySection": {
    "title": "Kategorienverteilung"
  },
  "month": {
    "current": "Diesen Monat",
    "next": "Nächsten Monat"
  },
  "questionHistoryTable": {
    "date": "Datum",
    "question": "Frage",
    "category": "Kategorie",
    "status": "Status",
    "lastAsked": "Zuletzt gestellt"
  }
}
